import { render, staticRenderFns } from "./CompaniesComponent.vue?vue&type=template&id=68575e0e"
import script from "./CompaniesComponent.vue?vue&type=script&lang=js"
export * from "./CompaniesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports